export const PRICE_LEVELS = {
  COMFORT: {
    id: 1,
    type: "Comfort",
    total: 0,
  },
  SUPERIOR: {
    id: 2,
    type: "Superior",
    total: 0,
  },
  LUXURY: {
    id: 3,
    type: "Luxury",
    total: 0,
  },
};

export const PRICE_TYPES = {
  SELLER: {
    id: 1,
    type: "seller",
    label: "SELLER",
  },
  RESELLER: {
    id: 2,
    type: "reseller",
    label: "RESELLER",
  },
};

export const PRICES_ALERT_MESSAGES = {
  MISSING_UPSALES: "Upsales has not been added!",
  PRICE_IS_NEGATIVE: "Level price is negative!",
};

export const DEFAULT_QUOTE_PRICES = [
  {
    type: "seller",
    selected_level: 0,
    prices: [
      {
        type: "Comfort",
        label: "Comfort",
        fee: 0,
        margin: 0,
        total: 0,
        hotel_total: 0,
        calculated_total: 0,
        margin_percentage_hotel: 0,
        margin_percentage_service: 0,
        sub_total_hotel: 0,
        sub_total_service: 0,
        services_total: 0,
        pax_prices: [
          {
            pax_id: "default-pax-id-1",
            price_saas: 0,
            price: 0,
            mkt_percentage: 0,
            mkt_coin: 0,
            fee: 0,
            total_price_saas: 0,
            total_price: 0,
            external_id: 0,
            total_cost: 0,
            id: 1,
            entity_uuid: "default-pax-entity-uuid-1",
            entity_id: 1,
            entity_parent_id: 1,
            entity_type_id: 1,
            status: 1,
            order: 1,
            modified: false,
            affected: false,
            restorable: true,
            created_by: 1,
            updated_by: 1,
            created_date: 0,
            updated_date: 0,
            owner_by: 1,
            version: 1,
            stable_version: 1,
            crc32: "default-crc32-1",
          },
        ],
        id: "default-comfort-id",
        entity_uuid: "default-comfort-entity-uuid",
        entity_id: 1,
        entity_parent_id: 1,
        entity_type_id: 1,
        status: 1,
        order: 1,
        modified: false,
        affected: false,
        restorable: true,
        created_by: 1,
        updated_by: 1,
        created_date: 0,
        updated_date: 0,
        owner_by: 1,
        version: 1,
        stable_version: 1,
        crc32: "default-comfort-crc32",
        level: 1,
      },
      {
        type: "Superior",
        label: "Superior",
        fee: 0,
        margin: 0,
        total: 0,
        hotel_total: 0,
        calculated_total: 0,
        margin_percentage_hotel: 0,
        margin_percentage_service: 0,
        sub_total_hotel: 0,
        sub_total_service: 0,
        services_total: 0,
        pax_prices: [
          {
            pax_id: "default-pax-id-1",
            price_saas: 0,
            price: 0,
            mkt_percentage: 0,
            mkt_coin: 0,
            fee: 0,
            total_price_saas: 0,
            total_price: 0,
            external_id: 0,
            total_cost: 0,
            id: 2,
            entity_uuid: "default-pax-entity-uuid-2",
            entity_id: 2,
            entity_parent_id: 1,
            entity_type_id: 1,
            status: 1,
            order: 1,
            modified: false,
            affected: false,
            restorable: true,
            created_by: 1,
            updated_by: 1,
            created_date: 0,
            updated_date: 0,
            owner_by: 1,
            version: 1,
            stable_version: 1,
            crc32: "default-crc32-2",
          },
        ],
        id: "default-superior-id",
        entity_uuid: "default-superior-entity-uuid",
        entity_id: 2,
        entity_parent_id: 1,
        entity_type_id: 1,
        status: 1,
        order: 2,
        modified: false,
        affected: false,
        restorable: true,
        created_by: 1,
        updated_by: 1,
        created_date: 0,
        updated_date: 0,
        owner_by: 1,
        version: 1,
        stable_version: 1,
        crc32: "default-superior-crc32",
        level: 2,
      },
      {
        type: "Luxury",
        label: "Luxury",
        fee: 0,
        margin: 0,
        total: 0,
        hotel_total: 0,
        calculated_total: 0,
        margin_percentage_hotel: 0,
        margin_percentage_service: 0,
        sub_total_hotel: 0,
        sub_total_service: 0,
        services_total: 0,
        pax_prices: [
          {
            pax_id: "default-pax-id-1",
            price_saas: 0,
            price: 0,
            mkt_percentage: 0,
            mkt_coin: 0,
            fee: 0,
            total_price_saas: 0,
            total_price: 0,
            external_id: 0,
            total_cost: 0,
            id: 3,
            entity_uuid: "default-pax-entity-uuid-3",
            entity_id: 3,
            entity_parent_id: 1,
            entity_type_id: 1,
            status: 1,
            order: 1,
            modified: false,
            affected: false,
            restorable: true,
            created_by: 1,
            updated_by: 1,
            created_date: 0,
            updated_date: 0,
            owner_by: 1,
            version: 1,
            stable_version: 1,
            crc32: "default-crc32-3",
          },
        ],
        id: "default-luxury-id",
        entity_uuid: "default-luxury-entity-uuid",
        entity_id: 3,
        entity_parent_id: 1,
        entity_type_id: 1,
        status: 1,
        order: 3,
        modified: false,
        affected: false,
        restorable: true,
        created_by: 1,
        updated_by: 1,
        created_date: 0,
        updated_date: 0,
        owner_by: 1,
        version: 1,
        stable_version: 1,
        crc32: "default-luxury-crc32",
        level: 3,
      },
    ],
    id: null,
    entity_uuid: "default-entity-uuid",
    entity_id: 1,
    entity_parent_id: 1,
    entity_type_id: 1,
    status: 1,
    order: 1,
    modified: false,
    affected: false,
    restorable: true,
    created_by: 1,
    updated_by: 1,
    created_date: 0,
    updated_date: 0,
    owner_by: 1,
    version: 1,
    stable_version: 1,
    crc32: "default-seller-crc32",
    label: "DEFAULT_SELLER",
  },
];
